/*

Taken from GroupedList.styles.ts in Fabric.
ADO 4048007: Find a way to avoid copying this file.

*/
import { IStyleFunction, getGlobalClassNames, AnimationVariables } from '@fluentui/react';
import {
    IGroupedComboBoxDropDownStyleProps,
    IGroupedComboBoxDropDownStyles,
} from './GroupedComboBoxDropDown.types';

const GlobalClassNames = {
    root: 'ms-GroupedComboBoxDropDown',
    group: 'ms-GroupedComboBoxDropDown-group',
    link: 'ms-Link',
    listCell: 'ms-List-cell',
};

const beziers = {
    easeInOutSine: 'cubic-bezier(0.445, 0.050, 0.550, 0.950)',
};

export const getStyles: IStyleFunction<
    IGroupedComboBoxDropDownStyleProps,
    IGroupedComboBoxDropDownStyles
> = (props) => {
    const { theme, className } = props;
    const { palette } = theme;
    const classNames = getGlobalClassNames(GlobalClassNames, theme);

    return {
        root: [
            classNames.root,
            theme.fonts.small,
            {
                position: 'relative',
                selectors: {
                    [`.${classNames.listCell}`]: {
                        minHeight: 38,
                    },
                },
            },
            className,
        ],
        group: [
            classNames.group,
            {
                transition: `background-color ${AnimationVariables.durationValue2} ${beziers.easeInOutSine}`,
            },
        ],
        groupIsDropping: {
            backgroundColor: palette.neutralLight,
        },
        subComponentStyles: {
            separatorStyles: {
                root: {
                    fontSize: 0,
                    marginLeft: '8px',
                    marginRight: '8px',
                },
            },
        },
    };
};
